// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"1f48e447","166":"3a303a34","343":"27bf5fbf","374":"89e0a48b","395":"1a6bc836","415":"f5cbdc3d","723":"dbb6e342","804":"f34a798d"}[chunkId] + ".chunk.css";
};